import { Icon32CheckCircle, Icon32ErrorCircle } from '@vkontakte/icons';
import clsx from 'clsx';
import React, { type ReactNode, memo } from 'react';

import styles from './InfoComponent.css';

interface IInfoComponentProps {
    type: 'info' | 'success';
    title: ReactNode;
    description: ReactNode;

    bttnText?: ReactNode;
    onClick?: () => void;
}

const getIcon = (type: 'info' | 'success') => {
    if (type === 'info') {
        return <Icon32ErrorCircle color="var(--cloud--color_text_accent_alternative)" />;
    } else if (type === 'success') {
        return <Icon32CheckCircle color="var(--vkui--color_background_positive)" />;
    }
};

export const InfoComponent = memo<IInfoComponentProps>(({ type, title, description, bttnText, onClick }) => {
    return (
        <div
            className={clsx(styles.root, {
                [styles[`root_${type}`]]: !!type,
            })}
            data-test-id="tgmig-status-infoblock"
        >
            <div className={styles.infoComponentIcon}>{getIcon(type)}</div>
            <div className={styles.infoComponentText}>
                <div className={styles.infoComponentTitle} data-test-id="tgmig-status-infoblock-title">
                    {title}
                </div>
                <div className={styles.infoComponentDescription}>{description}</div>
                {bttnText && (
                    <button className={styles.button} type="button" onClick={onClick} data-test-id="tgmig-status-infoblock-button">
                        {bttnText}
                    </button>
                )}
            </div>
        </div>
    );
});

InfoComponent.displayName = 'InfoComponent';
